import { getInsurancePaymentByFunction } from '@/common/queries/selections/insurancePaymentBy/insurancePaymentByFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInsurancePaymentByOption = () =>
  queryOptions({
    queryKey: ['get_insurance_payment_by'],
    queryFn: () => getInsurancePaymentByFunction(),
  });
